import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import momentTimeZone from "moment-timezone";
import { getUserInfoFromSession } from "../../../adapters/session/localSessionAdapter";
import { Modal, ModalBody, ModalFooter, Tooltip } from "reactstrap";
import config from "../../../config/config";
import DatePicker from "react-datepicker";
import { updateMovingDateInfoAPI } from "../../../adapters/dashboard/dashboardAdapater";

export function MoveDateModal(props) {
  const { isOpen, toggle, data } = props;
  const { handleSubmit, register, control } = useForm();

  const movingOnDate = data !== null ? new Date(data.moveDate) : new Date();
  const oldMovingOnDate = movingOnDate;
  
  const [error, setError] = useState(null);
  const [progress, updateProgress] = useState(false);
  const [toolTipOpen, setToolTipOpen] = useState(false);

  const getStatusForFlexibleInString = (status) => {
    return status === true ? "1" : "0";
  };
  
  const submitFn = async (formData) => {
    updateProgress(true);
    setError(null);
    if (
      new Date(formData["moving_on"]).getTime() - movingOnDate.getTime() ===
        0 &&
      data.moveDateFlexible ===
        getStatusForFlexibleInString(formData["move_date_flexible"])
    ) {
      updateProgress(false);
      setError("Please provide a new date/time before submitting.");
      return;
    }
    try {
      const utcMovingDate = momentTimeZone
        .tz(formData["moving_on"], "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
      const utcOldMovingDate = momentTimeZone
        .tz(oldMovingOnDate, "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
      const userSession = getUserInfoFromSession();

      const body = {
        estimate_id: data.estimateId,
        moving_on: utcMovingDate,
        moving_on_old: utcOldMovingDate,
        move_date_flexible: formData["move_date_flexible"] === true ? "1" : "0",
        status: data.status,
        user_id: userSession.userId,
      };
      const res = await updateMovingDateInfoAPI(body);
      if (res.data.meta.code === 200) {
        //update the UI with latest date in the list.
        //successfully updated the movedate.
        //close the modal and update the message.
        updateProgress(false);
        toggle();
      }
    } catch (e) {
      updateProgress(false);
      setError("An Error Occurred, Please try again later.");
      console.error("An Error occurred", e);
    }
  };
  const JSX = (
    <Modal isOpen={isOpen} size={"md"} centered={false} toggle={toggle}>
      <form onSubmit={handleSubmit(submitFn)}>
        <ModalBody className="mb-0">
          <h4 className="text-center">
            Update your relocation date for #{data !== null && data.estimateId}
          </h4>
          <div className="form-group">
            <Controller
              control={control}
              name="moving_on"
              rules={{
                validate: {
                  isRequired: (value) => value !== "",
                },
              }}
              defaultValue={movingOnDate}
              render={(props) => (
                <DatePicker
                  className="form-control text-center"
                  showTimeSelect
                  placeholderText="Moving date"
                  onChange={(e) => props.onChange(e)}
                  selected={props.value}
                  dateFormat="dd/MM/yyyy h:mm aa"
                  minDate={new Date()}
                  timeFormat="HH:mm"
                  timeIntervals={30}
                  timeCaption="Time"
                  showDisabledMonthNavigation
                />
              )}
            />
          </div>
          <div className="form-group mb-0 d-flex align-items-center justify-content-center">
            <div className="custom-control custom-checkbox mr-1">
              <input
                type="checkbox"
                className="custom-control-input"
                ref={register}
                defaultChecked={
                  data !== null
                    ? data.moveDateFlexible === "1"
                      ? true
                      : false
                    : false
                }
                name="move_date_flexible"
                id="move_date_flexible"
              />
              <label
                className="custom-control-label"
                htmlFor="move_date_flexible"
              >
                Is Flexible{" "}
              </label>
            </div>
            <Tooltip
              placement="right"
              isOpen={toolTipOpen}
              target="info_icon"
              toggle={() => {
                setToolTipOpen(!toolTipOpen);
              }}
            >
              If you are unsure about your move date, check this and revisit to
              alter before your actual move date.
            </Tooltip>
            <img
              src={`${config.customerPortal}assets/images/icons/info.png`}
              height="15"
              id="info_icon"
              width="15"
              alt="info"
            />
          </div>
          <div className="error-text text-center">
            {error !== null && error}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="submit"
            disabled={progress === true ? true : false}
            className="btn btn-sm btn-primary"
          >
            {progress === true && "Saving..."}
            {progress === false && "Update"}
          </button>
          <button
            className="btn btn-sm btn-dark"
            type="button"
            onClick={() => {
              setError(null);
              toggle();
            }}
          >
            Cancel
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
  return JSX;
}
